import { render, staticRenderFns } from "./PackageDialog.vue?vue&type=template&id=4ef677f8&scoped=true"
import script from "./PackageDialog.vue?vue&type=script&lang=ts"
export * from "./PackageDialog.vue?vue&type=script&lang=ts"
import style0 from "./PackageDialog.vue?vue&type=style&index=0&id=4ef677f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef677f8",
  null
  
)

export default component.exports